import React from 'react';
import styled from '@emotion/styled';
import { ITheme } from '../../../../../../ui';
import { useExtrasFormContext } from '../helpers/useExtrasFormContext';
import { getNestedInputName } from './getNestedInputName';
import { INestedInputLevel } from './INestedInputLevel';
import themed from '../../../../../../ui/themer/themed';
import { Path } from 'react-hook-form';
import { IExtrasFormData } from '../IExtrasFormData';

export interface INestedInputIdProps {
	level: INestedInputLevel;
	value: string | number;
}

export const NestedInputId = ({ level, value }: INestedInputIdProps) => {
	const { register } = useExtrasFormContext();

	const name = getNestedInputName(level, 'id') as Path<IExtrasFormData>;

	return <StyledInput type="hidden" value={value} {...register(name)} />;
};

const StyledInput = styled.input<{}, ITheme>`
	font-family: ${themed(({ typography }) => typography.body.fontFamily)};
`;
